'use client';

import { c as _c } from "react/compiler-runtime";
import type { ChartMetric } from './utils';
import type React from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { Dialog } from 'src/components/Molecules/Dialog';
import { MetricDialogTransition } from './motion';
interface MetricPickerDialogProps {
  open: boolean;
  metrics: ChartMetric[];
  draftId: string;
  onDraftChange: (metricId: string) => void;
  onClose: (apply: boolean) => void;
}
const MetricPickerDialog: React.FC<MetricPickerDialogProps> = t0 => {
  const $ = _c(16);
  const {
    open,
    metrics,
    draftId,
    onDraftChange,
    onClose
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      cancel: "Cancel",
      ok: "Apply"
    };
    t2 = {
      transition: MetricDialogTransition
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== onClose) {
    t3 = apply => onClose(!!apply);
    $[2] = onClose;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== onDraftChange) {
    t4 = event => onDraftChange(event.target.value);
    $[4] = onDraftChange;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== metrics) {
    t5 = metrics.map(_temp);
    $[6] = metrics;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== draftId || $[9] !== t4 || $[10] !== t5) {
    t6 = <RadioGroup aria-label="Metric" name="hero-chart-metric" value={draftId} onChange={t4}>{t5}</RadioGroup>;
    $[8] = draftId;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== open || $[13] !== t3 || $[14] !== t6) {
    t7 = <Dialog open={open} title="Choose metric" actions={t1} slots={t2} handleClose={t3}>{t6}</Dialog>;
    $[12] = open;
    $[13] = t3;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};
export default MetricPickerDialog;
function _temp(metric) {
  return <FormControlLabel key={metric.id} value={metric.id} control={<Radio />} label={metric.label} />;
}